import { render, staticRenderFns } from "./tzz_szp_syjl.vue?vue&type=template&id=bfb4458c&scoped=true"
import script from "./tzz_szp_syjl.vue?vue&type=script&lang=js"
export * from "./tzz_szp_syjl.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bfb4458c",
  null
  
)

export default component.exports